/**
 * Venue and Team Location Lookup
 *
 * Maps venue names and team names to location data for IPTC pre-fill.
 * Used for auto-suggesting location fields when venue is entered.
 */

// Venue location lookup for common Dutch/European stadiums
// Maps venue name (case-insensitive partial match) to location data
export const VENUE_LOCATIONS = {
  // Eredivisie
  'philips stadion': { city: 'Eindhoven', state: 'Brabant', country: 'The Netherlands', countryCode: 'NLD' },
  'philips': { city: 'Eindhoven', state: 'Brabant', country: 'The Netherlands', countryCode: 'NLD' },
  'de kuip': { city: 'Rotterdam', state: 'Zuid-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'stadion feijenoord': { city: 'Rotterdam', state: 'Zuid-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'johan cruijff arena': { city: 'Amsterdam', state: 'Noord-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'johan cruyff arena': { city: 'Amsterdam', state: 'Noord-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'amsterdam arena': { city: 'Amsterdam', state: 'Noord-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'galgenwaard': { city: 'Utrecht', state: 'Utrecht', country: 'The Netherlands', countryCode: 'NLD' },
  'gelredome': { city: 'Arnhem', state: 'Gelderland', country: 'The Netherlands', countryCode: 'NLD' },
  'abe lenstra': { city: 'Heerenveen', state: 'Friesland', country: 'The Netherlands', countryCode: 'NLD' },
  'euroborg': { city: 'Groningen', state: 'Groningen', country: 'The Netherlands', countryCode: 'NLD' },
  'cars jeans': { city: 'Den Haag', state: 'Zuid-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'bingoal': { city: 'Den Haag', state: 'Zuid-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'rat verlegh': { city: 'Breda', state: 'Brabant', country: 'The Netherlands', countryCode: 'NLD' },
  'de goffert': { city: 'Nijmegen', state: 'Gelderland', country: 'The Netherlands', countryCode: 'NLD' },
  'erve asito': { city: 'Almelo', state: 'Overijssel', country: 'The Netherlands', countryCode: 'NLD' },
  'polman': { city: 'Almelo', state: 'Overijssel', country: 'The Netherlands', countryCode: 'NLD' },
  'mac3park': { city: 'Zwolle', state: 'Overijssel', country: 'The Netherlands', countryCode: 'NLD' },
  'mandemakers': { city: 'Waalwijk', state: 'Brabant', country: 'The Netherlands', countryCode: 'NLD' },
  'covebo': { city: 'Sittard', state: 'Limburg', country: 'The Netherlands', countryCode: 'NLD' },
  'parkstad limburg': { city: 'Kerkrade', state: 'Limburg', country: 'The Netherlands', countryCode: 'NLD' },
  'afas': { city: 'Alkmaar', state: 'Noord-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'de adelaarshorst': { city: 'Deventer', state: 'Overijssel', country: 'The Netherlands', countryCode: 'NLD' },
  'sparta': { city: 'Rotterdam', state: 'Zuid-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'kasteel': { city: 'Rotterdam', state: 'Zuid-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'de grolsch veste': { city: 'Enschede', state: 'Overijssel', country: 'The Netherlands', countryCode: 'NLD' },
  'koning willem ii': { city: 'Tilburg', state: 'Brabant', country: 'The Netherlands', countryCode: 'NLD' },
  // Eerste Divisie
  'de vliert': { city: 'Den Bosch', state: 'Brabant', country: 'The Netherlands', countryCode: 'NLD' },
  'de braak': { city: 'Helmond', state: 'Brabant', country: 'The Netherlands', countryCode: 'NLD' },
  'kras': { city: 'Volendam', state: 'Noord-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'de oude meerdijk': { city: 'Emmen', state: 'Drenthe', country: 'The Netherlands', countryCode: 'NLD' },
  'cambuurstadion': { city: 'Leeuwarden', state: 'Friesland', country: 'The Netherlands', countryCode: 'NLD' },
  // International
  'wembley': { city: 'London', state: 'England', country: 'United Kingdom', countryCode: 'GBR' },
  'camp nou': { city: 'Barcelona', state: 'Catalonia', country: 'Spain', countryCode: 'ESP' },
  'santiago bernabeu': { city: 'Madrid', state: 'Madrid', country: 'Spain', countryCode: 'ESP' },
  'allianz arena': { city: 'Munich', state: 'Bavaria', country: 'Germany', countryCode: 'DEU' },
  'signal iduna': { city: 'Dortmund', state: 'North Rhine-Westphalia', country: 'Germany', countryCode: 'DEU' },
};

// Team home city lookup (for when venue is not provided)
export const TEAM_LOCATIONS = {
  'psv eindhoven': { city: 'Eindhoven', state: 'Brabant', country: 'The Netherlands', countryCode: 'NLD' },
  'psv': { city: 'Eindhoven', state: 'Brabant', country: 'The Netherlands', countryCode: 'NLD' },
  'feyenoord': { city: 'Rotterdam', state: 'Zuid-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'feyenoord rotterdam': { city: 'Rotterdam', state: 'Zuid-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'ajax': { city: 'Amsterdam', state: 'Noord-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'afc ajax': { city: 'Amsterdam', state: 'Noord-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'az': { city: 'Alkmaar', state: 'Noord-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'az alkmaar': { city: 'Alkmaar', state: 'Noord-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'fc utrecht': { city: 'Utrecht', state: 'Utrecht', country: 'The Netherlands', countryCode: 'NLD' },
  'fc twente': { city: 'Enschede', state: 'Overijssel', country: 'The Netherlands', countryCode: 'NLD' },
  'vitesse': { city: 'Arnhem', state: 'Gelderland', country: 'The Netherlands', countryCode: 'NLD' },
  'sc heerenveen': { city: 'Heerenveen', state: 'Friesland', country: 'The Netherlands', countryCode: 'NLD' },
  'fc groningen': { city: 'Groningen', state: 'Groningen', country: 'The Netherlands', countryCode: 'NLD' },
  'ado den haag': { city: 'Den Haag', state: 'Zuid-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'nac breda': { city: 'Breda', state: 'Brabant', country: 'The Netherlands', countryCode: 'NLD' },
  'nec': { city: 'Nijmegen', state: 'Gelderland', country: 'The Netherlands', countryCode: 'NLD' },
  'nec nijmegen': { city: 'Nijmegen', state: 'Gelderland', country: 'The Netherlands', countryCode: 'NLD' },
  'heracles': { city: 'Almelo', state: 'Overijssel', country: 'The Netherlands', countryCode: 'NLD' },
  'heracles almelo': { city: 'Almelo', state: 'Overijssel', country: 'The Netherlands', countryCode: 'NLD' },
  'pec zwolle': { city: 'Zwolle', state: 'Overijssel', country: 'The Netherlands', countryCode: 'NLD' },
  'rkc waalwijk': { city: 'Waalwijk', state: 'Brabant', country: 'The Netherlands', countryCode: 'NLD' },
  'fortuna sittard': { city: 'Sittard', state: 'Limburg', country: 'The Netherlands', countryCode: 'NLD' },
  'roda jc': { city: 'Kerkrade', state: 'Limburg', country: 'The Netherlands', countryCode: 'NLD' },
  'go ahead eagles': { city: 'Deventer', state: 'Overijssel', country: 'The Netherlands', countryCode: 'NLD' },
  'sparta rotterdam': { city: 'Rotterdam', state: 'Zuid-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'excelsior': { city: 'Rotterdam', state: 'Zuid-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'willem ii': { city: 'Tilburg', state: 'Brabant', country: 'The Netherlands', countryCode: 'NLD' },
  'fc volendam': { city: 'Volendam', state: 'Noord-Holland', country: 'The Netherlands', countryCode: 'NLD' },
  'fc emmen': { city: 'Emmen', state: 'Drenthe', country: 'The Netherlands', countryCode: 'NLD' },
  'sc cambuur': { city: 'Leeuwarden', state: 'Friesland', country: 'The Netherlands', countryCode: 'NLD' },
  'fc den bosch': { city: 'Den Bosch', state: 'Brabant', country: 'The Netherlands', countryCode: 'NLD' },
  'helmond sport': { city: 'Helmond', state: 'Brabant', country: 'The Netherlands', countryCode: 'NLD' },
};

/**
 * Look up location data from venue name
 * @param {string} venue - Venue/stadium name
 * @returns {Object|null} Location data or null if not found
 */
export function lookupVenueLocation(venue) {
  if (!venue) return null;

  const venueLower = venue.toLowerCase();
  for (const [key, location] of Object.entries(VENUE_LOCATIONS)) {
    if (venueLower.includes(key)) {
      return location;
    }
  }

  return null;
}

/**
 * Look up location data from team name (fallback when venue not found)
 * @param {string} teamName - Team name
 * @returns {Object|null} Location data or null if not found
 */
export function lookupTeamLocation(teamName) {
  if (!teamName) return null;

  const teamLower = teamName.toLowerCase();
  if (TEAM_LOCATIONS[teamLower]) {
    return TEAM_LOCATIONS[teamLower];
  }

  // Try partial match
  for (const [key, location] of Object.entries(TEAM_LOCATIONS)) {
    if (teamLower.includes(key) || key.includes(teamLower)) {
      return location;
    }
  }

  return null;
}

/**
 * Look up location data from venue or home team (venue takes priority)
 * @param {string} venue - Venue/stadium name
 * @param {string} homeTeamName - Home team name (fallback)
 * @returns {Object|null} Location data or null if not found
 */
export function lookupLocation(venue, homeTeamName) {
  return lookupVenueLocation(venue) || lookupTeamLocation(homeTeamName);
}
